var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.043 3.54297H21.9596C26.6541 3.54297 30.4596 7.34855 30.4596 12.043V21.9596C30.4596 26.6541 26.6541 30.4596 21.9596 30.4596H12.043C7.34855 30.4596 3.54297 26.6541 3.54297 21.9596V12.043C3.54297 7.34855 7.34855 3.54297 12.043 3.54297ZM21.9596 28.3346C25.4772 28.3268 28.3268 25.4772 28.3346 21.9596V12.043C28.3268 8.52539 25.4772 5.67576 21.9596 5.66797H12.043C8.52539 5.67576 5.67576 8.52539 5.66797 12.043V21.9596C5.67576 25.4772 8.52539 28.3268 12.043 28.3346H21.9596Z",
    fill: "#0B0B0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5063 9.91797C20.9227 9.9256 20.4514 10.3969 20.4438 10.9805C20.429 11.8748 20.0566 12.7258 19.4097 13.3435C18.7627 13.9611 17.8953 14.2938 17.0013 14.2671C15.1599 14.3228 13.6204 12.8784 13.5588 11.0371C13.5588 10.4503 13.0831 9.97464 12.4963 9.97464C11.9095 9.97464 11.4338 10.4503 11.4338 11.0371C11.4958 14.0519 13.9865 16.4475 17.0013 16.3921C20.0162 16.4475 22.5068 14.0519 22.5688 11.0371C22.5844 10.7457 22.4793 10.4606 22.2784 10.2489C22.0774 10.0372 21.7982 9.91755 21.5063 9.91797Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconBlack);
export default __webpack_public_path__ + "static/media/cartIconBlack.43464338da84422c7d676fd17ea77721.svg";
export { ForwardRef as ReactComponent };